import type { TenantInheritanceFieldConfig } from "@/v2/framework/dialog/types";

import { readEntitySlice } from "./entitySlice";
import { resolveEntityPath } from "./resolveBinding";

function normalizeInheritableValue(raw: unknown): unknown {
  if (Array.isArray(raw)) return raw;
  if (raw === null || raw === undefined) return "";
  return raw;
}

export function readInheritanceInitialValue(
  row: unknown,
  path: string,
  fieldName: string,
  config: TenantInheritanceFieldConfig,
): unknown {
  const record = row && typeof row === "object" ? (row as Record<string, unknown>) : {};
  const entityPath = resolveEntityPath(path, config);
  const entity = readEntitySlice(record, entityPath);
  if (!entity) return undefined;

  const raw = entity[config.computedKey] ?? entity[fieldName];
  return normalizeInheritableValue(raw);
}
